var exports = {
  "a": "Box__cmuMWM",
  "w": "Box_1__QcAynM",
};

module.exports = exports;
